module.exports = __webpack_public_path__ + "img/checklist.0a7d85a0.svg";